import { IChecklist } from "@signal/asp-data-commons";
import * as fromActions from './checklist.actions';
import produce from 'immer';

export interface ChecklistState {
  selectedChecklist: string | null;
  allChecklist: IChecklist[];
  loading: boolean;
  loaded: boolean;
  error: string;
}


export const ChecklistInitiaState: ChecklistState = {
  selectedChecklist: null,
  allChecklist: [],
  loading: false,
  loaded: false,
  error: '',
}

export function checklistReducer(state: ChecklistState = ChecklistInitiaState,
  action: fromActions.ChecklistActions): ChecklistState {

  switch (action.type) {
    case fromActions.ChecklistActionTypes.LOAD_ALL_CHECKLIST: {
      return {
        ...state,
        allChecklist: [],
        loading: true,
        loaded: false,
        selectedChecklist: null
      };
    }

    case fromActions.ChecklistActionTypes.LOAD_ALL_CHECKLIST_SUCCESS: {
      const checklist = action instanceof fromActions.LoadAllChecklistSuccess ? action.payload.checklistDetails : [];
      return {
        ...state,
        allChecklist: checklist,
        loading: false,
        loaded: true,
      };
    }

    case fromActions.ChecklistActionTypes.LOAD_ALL_CHECKLIST_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action instanceof fromActions.LoadAllChecklistFailure ? action.payload.error : ''
      }
    }

    case fromActions.ChecklistActionTypes.LOAD_CHECKLIST: {
      return {
        ...state,
        selectedChecklist: action instanceof fromActions.LoadChecklist ? action.payload.checklist : null
      };
    }

    case fromActions.ChecklistActionTypes.UPDATE_CHECKLIST: {
      return {
        ...state
      };
    }
    case fromActions.ChecklistActionTypes.UPDATE_CHECKLIST_SUCCESS: {
      const payload = action instanceof fromActions.UpdateChecklistSuccess ? action.payload.checklist : null;
      return produce(state, draftState => {
        draftState.allChecklist.forEach((obj, index) => {
          if (obj.checklistId === payload.checklistId) {
            draftState.allChecklist[index] = { ...state.allChecklist[index], ...payload };
          }
        })
      });
    }
    case fromActions.ChecklistActionTypes.UPDATE_CHECKLIST_FAILURE: {
      return {
        ...state,
        error: action instanceof fromActions.UpdateChecklistFailure ? action.payload.error : ''
      };
    }

    default:
      return state;

  }
}  